module.exports = __webpack_public_path__ + "static/media/iconClasses.78b4a332.svg";